<template>
  <div class="cardd">
    <div class="card-content">
      <div class="title-section">
        <h1 class="main-title"><span class="word-nuestra">NUESTRA</span> TARJETA</h1>
      </div>

      <div class="features-container">
        <div class="feature-card">
          <div class="feature-image">
            <img src="../assets/IMG/post2.webp" alt="NFC" />
          </div>
          <h2 class="feature-title">NFC</h2>
          <p class="feature-text">
            Contamos con un sistema NFC, el cual permite la comunicación de corto alcance entre dos dispositivos por medio del contacto.
          </p>
        </div>

        <div class="feature-card">
          <div class="feature-image">
            <img src="../assets/IMG/codigo2.webp" alt="Sostenibilidad" />
          </div>
          <h2 class="feature-title">SOSTENIBILIDAD</h2>
          <p class="feature-text">
            Al utilizar tarjetas digitales, contribuyes a reducir el consumo de papel y plástico, lo que ayuda al medio ambiente.
          </p>
        </div>

        <div class="feature-card">
          <div class="feature-image">
            <img src="../assets/IMG/qr2.webp" alt="QR" />
          </div>
          <h2 class="feature-title">QR</h2>
          <p class="feature-text">
            Contamos con un código de respuesta rápida que al ser escaneado con la cámara permite visualizar la información almacenada.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {},
  data() {
    return {
    };
  },
};
</script>

<style scoped>
.cardd {
  background-color: #050505;
  min-height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 20px;
  position: relative;
  margin: 0;
 
}

.cardd::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('../assets/IMG/NOSOTROS.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  pointer-events: none;
  z-index: -1;
}

.card-content {
  width: 100%;
  max-width: 1200px;
}

.title-section {
  margin-bottom: 5px;
}

.main-title {
  font-family: "Exo", sans-serif;
  font-size: clamp(2.5rem, 5.5vw, 4.5rem);
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  line-height: 1.1;
}

.word-nuestra {
  font-family: "TT Chocolates", sans-serif;
  font-weight: 200;
  letter-spacing: -0.02em;
  display: block;
  font-size: 0.85em;
}

.features-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  justify-items: center;
}

.feature-card {
  text-align: center;
  max-width: 320px;
}

.feature-image {
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

.feature-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 12px;
}

.feature-title {
  font-family: "Exo", sans-serif;
  font-size: clamp(1.5rem, 3vw, 2.2rem);
  font-weight: 700;
  color: #ffffff;
  margin: 20px 0 15px 0;
  letter-spacing: 0.05em;
}

.feature-text {
  font-family: "Exo", sans-serif;
  font-size: clamp(0.95rem, 1.5vw, 1.1rem);
  color: #d0d0d0;
  font-weight: 300;
  line-height: 1.6;
  margin: 0;
}

@media (max-width: 1024px) {
  .features-container {
    gap: 30px;
  }

  .feature-card {
    max-width: 280px;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .cardd {
    padding: 20px 20px;
    min-height: auto;
  }

  .card-content {
    max-width: 900px;
  }

  .title-section {
    margin-bottom: 25px;
  }

  .main-title {
    font-size: clamp(2.2rem, 5vw, 3.5rem);
  }

  .features-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    justify-items: center;
  }

  .feature-card {
    max-width: 100%;
  }

  .feature-card:nth-child(3) {
    grid-column: 1 / -1;
    max-width: 480px;
  }

  .feature-image {
    height: 160px;
    margin-bottom: 20px;
  }

  .feature-title {
    font-size: 1.3rem;
    margin: 15px 0 10px 0;
  }

  .feature-text {
    font-size: 0.95rem;
  }
}

@media (max-width: 768px) {
  .cardd {
    padding: 40px 20px;
  }

  .features-container {
    grid-template-columns: 1fr;
    gap: 50px;
  }

  .title-section {
    margin-bottom: 50px;
  }

  .feature-card {
    max-width: 100%;
  }

  .feature-image {
    height: 180px;
  }
}

@media (max-width: 480px) {
  .cardd {
    padding: 30px 15px;
  }

  .main-title {
    font-size: 2.5rem;
  }

  .feature-title {
    font-size: 1.3rem;
  }

  .feature-text {
    font-size: 0.95rem;
  }

  .title-section {
    margin-bottom: 40px;
  }

  .features-container {
    gap: 40px;
  }
}
</style>
